import React, { useEffect } from 'react';

import CloseIcon from '@mui/icons-material/Close';

import {
  AdapterDayjs,
  IconButton,
  Loader,
  LocalizationProvider,
} from 'components';
import { useAuth, useTenant } from 'hooks';

import { SupportChat } from './SupportChat';

import {
  RouterOutlet,
  SnackbarKey,
  SnackbarProvider,
  createGlobalStyle,
  cssResetStyles,
  useSelector,
  useSnackbar,
} from 'third-party';

import { useSettings } from 'modules/setting';

import { appSelectors } from 'selectors';

import { TourContainer, useCheckTour } from 'utils/tour';

const GlobalStyle = createGlobalStyle`
  ${cssResetStyles}
 

  html {
    font-family: 'Montserrat', 'Inter', sans-serif;
  }

  input::-ms-reveal { display: none; }

  #root {
    display: flex;
    height: 100%;
  }
`;

const SnackbarCloseButton = ({ snackbarKey }: { snackbarKey: SnackbarKey }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CloseIcon style={{ fill: 'white' }} />
    </IconButton>
  );
};

export const MainContainer = () => {
  return (
    <TourContainer>
      <SnackbarProvider
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        action={snackbarKey => (
          <SnackbarCloseButton snackbarKey={snackbarKey} />
        )}
      >
        <GlobalStyle />
        <RouterOutlet />
      </SnackbarProvider>
    </TourContainer>
  );
};

export const AppContainer = () => {
  const isAppLoaded = useSelector(appSelectors.isAppLoaded);
  const tenantId = useSelector(appSelectors.tenantId);

  useTenant();
  useCheckTour();
  useAuth();

  const { loadSettings } = useSettings();

  useEffect(() => {
    if (tenantId) {
      loadSettings();
    }
  }, [loadSettings, tenantId]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {!isAppLoaded ? <Loader /> : <RouterOutlet />}
      <SupportChat />
    </LocalizationProvider>
  );
};
